module.exports = __webpack_public_path__ + "img/checks.31327d34.svg";